

















































































































































































































































































































































































import Vue from "vue";
import dayjs from "dayjs";
import eventBus from "@/services/eventBus";
import base64toUInt8Array, { openPdfInNewTab } from "@/utils/fileConvert";
import DateInput from "@/components/DateInput.vue";
import LookupComboBox from "@/modules/transactions/components/LookupComboBox.vue";
import api from "../services/api";
import {
  ParamReportFilter,
  DefaultParamReportFilter,
  ParamReportOrderByOptions,
  ParamReportRow,
} from "../models/ParamReport";

// A LookupComboBox textField-je string mezőt vár — az id szöveges tükrével bővített lookup-elem.
interface TransactionOption {
  id: number;
  accEvent: string;
  idText: string;
}

// Pipálható választó-grid sora (K2D d_g_boktype / d_g_prefix 'sel' oszlopa; default: mind kijelölve).
interface SelectableBookTypeRow {
  id: number;
  name: string;
  selected: boolean;
}
interface SelectablePrefixRow {
  code: string;
  selected: boolean;
}

interface Data {
  filter: ParamReportFilter;
  printCoverPage: boolean;
  bookTypeRows: SelectableBookTypeRow[];
  prefixRows: SelectablePrefixRow[];
  selectedBookTypeIds: number[];
  selectedPrefixCodes: string[];
  dimensionCodes: any[];
  recorderOptions: { id: number; name: string }[];
  transactionOptions: TransactionOption[];
  orderByOptions: { id: string; name: string }[];
  rows: ParamReportRow[];
  total: number;
  skip: number;
  take: number;
  pageable: any;
  searching: boolean;
  exporting: boolean;
  printing: boolean;
  columns: any[];
}
interface Methods {
  loadLookups(): Promise<void>;
  loadTransactions(): Promise<void>;
  loadDimensions(): Promise<void>;
  dimCodesFor(type: number): any[];
  onDimChange(
    field: "dim1From" | "dim1To" | "dim2From" | "dim2To" | "dim3From" | "dim3To",
    item: any
  ): void;
  syncSelectedIds(): void;
  removeBookType(id: number): void;
  removePrefix(code: string): void;
  selectAllBookTypes(all: boolean): void;
  selectAllPrefixes(all: boolean): void;
  onTransIdChange(field: "transIdFrom" | "transIdTo", item: TransactionOption | null): void;
  normalizedFilter(): ParamReportFilter;
  search(resetPage: boolean): Promise<void>;
  pageChangeHandler(event: any): void;
  exportExcel(): Promise<void>;
  printPdf(): Promise<void>;
  reset(): void;
  formatValue(v: number | null): string;
  formatDate(v: string | null): string;
}
interface Computed {
  totalFromDisplay: string;
  totalToDisplay: string;
}

// Összeg-mező hu-HU formázása / visszaolvasása (TransactionItemEdit totalDisplay minta)
function formatTotal(v: number | null): string {
  return v === null || v === undefined || isNaN(v)
    ? ""
    : new Intl.NumberFormat("hu-HU", { maximumFractionDigits: 2 }).format(v);
}
function parseTotal(val: string): number | null {
  const numeric = parseFloat(val.replace(/\s/g, "").replace(",", "."));
  return isNaN(numeric) ? null : numeric;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: { DateInput, LookupComboBox },

  data(): Data {
    return {
      filter: { ...DefaultParamReportFilter },
      printCoverPage: true,
      bookTypeRows: [],
      prefixRows: [],
      selectedBookTypeIds: [],
      selectedPrefixCodes: [],
      dimensionCodes: [],
      recorderOptions: [],
      transactionOptions: [],
      orderByOptions: ParamReportOrderByOptions,
      rows: [],
      total: 0,
      skip: 0,
      take: 50,
      pageable: { pageSizes: [25, 50, 100] },
      searching: false,
      exporting: false,
      printing: false,
      columns: [
        { field: "id", title: "Azonosító", width: "110px" },
        { field: "transId", title: "Tranzakció", width: "110px" },
        { field: "accDate", title: "Dátum", width: "100px", cell: "accDateTemplate" },
        { field: "debit", title: "Tartozik", width: "120px", cell: "debitTemplate" },
        { field: "credit", title: "Követel", width: "120px", cell: "creditTemplate" },
        { field: "accno", title: "Fksz.", width: "110px" },
        { field: "dim1", title: "I. dim", width: "90px" },
        { field: "dim2", title: "II. dim", width: "90px" },
        { field: "dim3", title: "III. dim", width: "90px" },
        { field: "bookTypeName", title: "Napló", width: "140px" },
        { field: "prefix", title: "Prefix", width: "80px" },
        { field: "invNo", title: "Bizonylat", width: "110px" },
        { field: "accEvent", title: "Gazdasági esemény", width: "200px" },
        { field: "note", title: "Megnevezés", width: "200px" },
        { field: "statusName", title: "Állapot", width: "140px" },
        { field: "remark", title: "Megjegyzés", width: "160px" },
        { field: "transTypeName", title: "Típus", width: "120px" },
        { field: "insDate", title: "Létrehozva", width: "110px", cell: "insDateTemplate" },
        { field: "recorderName", title: "Rögzítő", width: "150px" },
        { field: "storno", title: "Sztornó", width: "80px" },
        { field: "transSt", title: "Átvezető tr.", width: "110px" },
      ],
    };
  },

  async beforeMount() {
    await Promise.all([this.loadLookups(), this.loadTransactions(), this.loadDimensions()]);
  },

  computed: {
    totalFromDisplay: {
      get(): string {
        return formatTotal(this.filter.totalFrom);
      },
      set(val: string) {
        this.filter.totalFrom = parseTotal(val);
      },
    },
    totalToDisplay: {
      get(): string {
        return formatTotal(this.filter.totalTo);
      },
      set(val: string) {
        this.filter.totalTo = parseTotal(val);
      },
    },
  },

  methods: {
    async loadLookups() {
      try {
        const lookups = await api.GetParamReportLookups();
        // K2D retrieveend: napló és prefix alapból MIND kijelölve
        this.bookTypeRows = lookups.bookTypes.map(x => ({ id: x.id, name: x.name, selected: true }));
        this.prefixRows = lookups.prefixes.map(x => ({ code: x.code, selected: true }));
        this.recorderOptions = lookups.recorders;
        this.selectAllBookTypes(true);
        this.selectAllPrefixes(true);
      } catch (error) {
        console.error(error);
        eventBus.$emit("error", "A szűrő-listák betöltése nem sikerült!");
      }
    },

    async loadTransactions() {
      try {
        this.transactionOptions = (await api.GetParamReportTransactions()).map(x => ({
          id: x.id,
          accEvent: x.accEvent,
          idText: String(x.id),
        }));
      } catch (error) {
        console.error(error);
        eventBus.$emit("error", "A tranzakció-lista betöltése nem sikerült!");
      }
    },

    // Dimenzió-kódok (mmbokdimcode) a dim1-3 választókhoz — a BookingTemplateEditor mintája:
    // az aktuális naptári évhez tartozó könyvelési év, különben a legfrissebb.
    async loadDimensions() {
      try {
        const years = await api.GetGeneralLedgerYears();
        const current = new Date().getFullYear();
        const match = years.find(y => Number(y.year) === current);
        const sorted = [...years].sort((a, b) => Number(b.year) - Number(a.year));
        const year = match ? Number(match.year) : sorted.length ? Number(sorted[0].year) : 0;
        this.dimensionCodes = year ? await api.GetDimensionCodesByYear(year) : [];
      } catch (error) {
        console.error(error);
        eventBus.$emit("error", "A dimenzió-listák betöltése nem sikerült!");
      }
    },

    // type 2 = dim1, 3 = dim2, 4 = dim3
    dimCodesFor(type: number): any[] {
      return this.dimensionCodes.filter(d => d.type === type);
    },

    // A lookupból választott sor dimenzió kódja kerül az intervallum-mezőbe (üres = nincs szűrés)
    onDimChange(
      field: "dim1From" | "dim1To" | "dim2From" | "dim2To" | "dim3From" | "dim3To",
      item: any
    ) {
      this.filter[field] = item && item.dimcode ? String(item.dimcode) : "";
    },

    syncSelectedIds() {
      this.filter.bookTypeIds = [...this.selectedBookTypeIds];
      this.filter.prefixes = [...this.selectedPrefixCodes];
    },

    // A chipen lévő x: egy elem kivétele a kijelölésből
    removeBookType(id: number) {
      this.selectedBookTypeIds = this.selectedBookTypeIds.filter(x => x !== id);
      this.syncSelectedIds();
    },

    removePrefix(code: string) {
      this.selectedPrefixCodes = this.selectedPrefixCodes.filter(x => x !== code);
      this.syncSelectedIds();
    },

    selectAllBookTypes(all: boolean) {
      this.selectedBookTypeIds = all ? this.bookTypeRows.map(r => r.id) : [];
      this.syncSelectedIds();
    },

    selectAllPrefixes(all: boolean) {
      this.selectedPrefixCodes = all ? this.prefixRows.map(r => r.code) : [];
      this.syncSelectedIds();
    },

    // A lookupból választott sor Tranzakció ID-ja kerül az intervallum-mezőbe
    onTransIdChange(field: "transIdFrom" | "transIdTo", item: TransactionOption | null) {
      this.filter[field] = item ? Number(item.idText) || 0 : 0;
    },

    // az üres szám-mezők ('' / NaN) nullázása a kérés előtt
    normalizedFilter(): ParamReportFilter {
      const f = { ...this.filter };
      f.totalFrom = typeof f.totalFrom === "number" && !isNaN(f.totalFrom) ? f.totalFrom : null;
      f.totalTo = typeof f.totalTo === "number" && !isNaN(f.totalTo) ? f.totalTo : null;
      f.transIdFrom = f.transIdFrom || 0;
      f.transIdTo = f.transIdTo || 0;
      f.recorderId = f.recorderId || 0;
      return f;
    },

    async search(resetPage: boolean) {
      if (resetPage) this.skip = 0;
      this.searching = true;
      try {
        const page = Math.floor(this.skip / this.take) + 1;
        const result = await api.SearchParamReport(this.normalizedFilter(), page, this.take);
        this.rows = result.currentPage;
        this.total = result.totalCount;
      } catch (error) {
        console.error(error);
        eventBus.$emit("error", "A listázás nem sikerült!");
      } finally {
        this.searching = false;
      }
    },

    pageChangeHandler(event: any) {
      this.skip = event.page.skip;
      this.take = event.page.take;
      this.search(false);
    },

    async exportExcel() {
      this.exporting = true;
      try {
        const file = await api.GetParamReportExcel(this.normalizedFilter());
        if (!file) {
          eventBus.$emit("error", "Az Excel export nem sikerült!");
          return;
        }
        const downloadLink = document.createElement("a");
        downloadLink.href = `data:application/vnd.openxmlformats;base64,${file}`;
        downloadLink.download = `Parameteres_riport.xlsx`;
        downloadLink.click();
      } catch (error) {
        console.error(error);
        eventBus.$emit("error", "Az Excel export nem sikerült!");
      } finally {
        this.exporting = false;
      }
    },

    async printPdf() {
      this.printing = true;
      eventBus.$emit("busy-message", true);
      try {
        const result = await api.GetParamReportPdf(this.normalizedFilter(), this.printCoverPage);
        if (!result.success || !result.pdf) {
          // K2D "NINCS" ág: nincs a feltételeknek megfelelő adat
          eventBus.$emit("error", result.message || "A riport elkészítése nem sikerült!");
          return;
        }
        openPdfInNewTab(base64toUInt8Array(result.pdf));
      } catch (error) {
        console.error(error);
        eventBus.$emit("error", "A riport elkészítése nem sikerült!");
      } finally {
        this.printing = false;
        eventBus.$emit("busy-message", false);
      }
    },

    // K2D pb_urit: szűrők alaphelyzetbe, listák mind kijelölve
    reset() {
      this.filter = { ...DefaultParamReportFilter };
      this.printCoverPage = true;
      this.selectAllBookTypes(true);
      this.selectAllPrefixes(true);
      this.rows = [];
      this.total = 0;
      this.skip = 0;
    },

    formatValue(v: number | null): string {
      if (v === null || v === undefined) return "";
      return v.toLocaleString("hu-HU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    formatDate(v: string | null): string {
      if (!v) return "";
      return dayjs(v).format("YYYY.MM.DD");
    },
  },
});
